export const getColumns: any = [
  {
    title: 'Context',
    field: 'authContext',
    headerStyle: { zIndex: 11 },
    width: '10%'
  },
  {
    title: 'Identifier',
    field: 'identifier',
    headerStyle: { zIndex: 11 },
    width: '10%',
    render: (rowData: any) => {
      return rowData?.additionalCreds?.primary?.identifier ? rowData?.additionalCreds?.primary?.identifier : '';
    }
  },
  {
    title: 'Authentication Mode',
    field: 'authMode',
    headerStyle: { zIndex: 11 },
    width: '15%'
  },
  {
    title: 'Is Default',
    field: 'defaultAuth',
    headerStyle: { zIndex: 11 },
    width: '10%',
    render: (rowData: any) => {
      return rowData.defaultAuth === true ? 'Yes' : 'No';
    }
  }
];

export default getColumns;
